module.exports = __webpack_public_path__ + "img/howto_ico05.f3986430.png";